module.exports = __webpack_public_path__ + "img/ywcj-gyljr_cpyt.949335c9.png";